var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsernameAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Success Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-\\u2699\\uFE0F-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setup-/-validated",
    transform: "translate(-299.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Field",
    transform: "translate(39.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(260.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.500000, 15.500000) rotate(-6.000000) translate(-14.500000, -15.500000) translate(6.000000, 10.000000)",
    stroke: "#07EC62",
    strokeLinecap: "square",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.192062412,5.36152236 L5.85406651,10.9884233 M5.85406651,10.9884233 L16.3778273,0.406179607",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernameAvailable);
export default __webpack_public_path__ + "static/media/usernameAvailable.8265dab9409142019d1e61b3b57ffb64.svg";
export { ForwardRef as ReactComponent };